import { AccountButton } from '@/components/shared/components/AccountButton';
import { SuperSearchBarTrigger } from '@/components/shared/components/SuperSearchBar/SuperSearchBarTrigger';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { useConfigContext } from '@/contexts/ConfigContext/ConfigContext';

export const MenuBottom = () => {
  const {
    state: { currentLayout },
  } = useConfigContext();

  const hasAccountPage = currentLayout?.pagesByPath[DYNAMIC_PAGE_PATHS.ACCOUNT];

  const hasSuperSearchBar = currentLayout?.showSuperSearchBar;

  return (
    <>
      {hasSuperSearchBar && <SuperSearchBarTrigger />}
      <AccountButton disabled={!hasAccountPage} />
    </>
  );
};
